import React from 'react';
import { js_utils } from "../utils/frfr-js-utils";


/*
PROPS:
props.src
props.width
props.height

*/


const FrfrAlienGoogleMapsIframeBySrc = (props) => {
  // 

  /*
  Viceroy Kopaonik Serbia
  
  Viceroy Kopaonik Serbia
  Trg Josifa Pancica 12, Копаоник 36354
  
  Link to share
  https://maps.app.goo.gl/v9qont9r7NeMT35X7
  
  Embed a map
  
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2106.245080677087!2d20.810460648614217!3d43.28468002720609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47563d9602477f79%3A0x52550d98f0ace663!2sViceroy%20Kopaonik%20Serbia!5e1!3m2!1ssr!2srs!4v1765840972931!5m2!1ssr!2srs" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  
  */

  // const example_src_kopaonik_viceroy = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2106.245080677087!2d20.810460648614217!3d43.28468002720609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47563d9602477f79%3A0x52550d98f0ace663!2sViceroy%20Kopaonik%20Serbia!5e1!3m2!1ssr!2srs!4v1765840972931!5m2!1ssr!2srs";


  // google_maps_iframe_src
  return (
    <>
      <div className="frfr-novo-alien-google-maps-iframe-container unirole-scope-without-default-transition">
        <iframe
          src={js_utils.fix_always_string(props.src)}
          width={props.width}
          height={props.height}
          style={{
            border: 0,
            // width: '100%',
            // height: '100%',
          }} // Corrected style attribute for JSX
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="" // Added title for accessibility
        ></iframe>
      </div>
    </>
  );
};

export default FrfrAlienGoogleMapsIframeBySrc;
